// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"185":"3cf073","639":"fc16fc","867":"63b2fa"}[chunkId] + ".js";
};